<template>
<footer>
	<div class="footer">
	  <el-row>
	    <el-col class="footer-content" :span="22" :offset="1">
	      <el-row class="footer-area">
	        <el-col :span="12" class="footer-box">
	          <h3>一路高歌物流科技有限公司</h3>
	          <ul class="list">
	            <li>营业执照：91330304MA2ATCMK4X  </li>
	            <li>备案号码：<a href="http://beian.miit.gov.cn/" target="_blank">浙ICP备2021006564号</a> </li>
	            <li>地址：浙江省温州市瓯海区潘桥街道福州路666号配载楼（2楼）245号 </li>
	          </ul>
	        </el-col>
	        <el-col :span="6" class="footer-box">
	          <h3>联系我们</h3>
	          <ul class="list">
	            <li>电话：0577-85625556 </li>
	            <li>邮箱：admin@ylgg56.com </li>
	            <li>Q&nbsp;&nbsp;Q：451089375 </li>
	          </ul>
	        </el-col>
	        <el-col :span="6" class="footer-box">
				<div class="d-flex align-items-center justify-content-space-between">
				  <div>
					<h3>售前咨询</h3>
					<ul class="list">
					  <li><a href="#">专业技术咨询</a></li>
					  <li><a href="#">全方位产品解读</a></li>
					  <li><a href="#">成功客户案例</a></li>
					</ul>
				  </div>
				  <div align="center">
					<el-image style="height:100px;width:100px;" :src="qrCodeUrl"></el-image>
				   <div>一路高歌</div>
				  </div>
			  </div>
	        </el-col>
	      </el-row>
	    </el-col>
	  </el-row>
	</div>
	<!--  底部  -->
	<div class="copyright">
	  <span>Copyright © 2021 一路高歌物流科技有限公司 All Rights Reserved.</span>
	</div>
</footer>
</template>

<script setup>
	import qrCodeUrl from '@/assets/qrcode.png'
	
</script>

<style lang="scss" scoped>
	.footer {
		background-color: #585c61;
		color: #999999;
		font-size: 13px;
		
		a { color: #999; }
		a:hover {
			text-decoration: underline;
		}
		
		.footer-area {
			border-top: 1px solid rgba(96, 96, 96, 0.25);
			border-bottom: 1px solid rgba(96, 96, 96, 0.25);
			padding: 2em 1em;
			
			.footer-box {
				h3 {
					color: #fff;
					font-weight: bold;
					margin-bottom: .5rem;;
				}
				.list {
					list-style-type: none;
					margin: 0;
					padding: 0;
					
					li {
						padding: 0.25em;
					}
				}
			}
		}
	}
	
	.copyright {
		background-color: #464A4E;
		color: #999999;
		line-height: 1.25em;
		text-align: center;
		font-size: 13px;
		letter-spacing: 1px;
		padding: 1.5em 2.5em;
	}
</style>